export default {
  headerOneUser: 'Are you sure you want to delete',
  headerMoreUsers: 'Are you sure you want to delete the following teammates?',
  warningMsg: 'This action cannot be undone',
  warningImgAlt: 'exclamation-triangle',
  deleteOneBtn: 'Delete Teammate',
  deleteMoreBtn: 'Delete Teammates',
};
